function PageTitle({ title }: { title: string }) {
  return (
    <span className="truncate whitespace-pre-wrap text-20 font-bold text-gray-151618 md:text-28">
      {title}
    </span>
  );
}

export default PageTitle;
